import marketingText from './MarketingText';

export default marketingText;
